import { useState } from "react";

import { Button, InfoModal, useModal, PlusSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import AdminConsoleSchoolGeneralInformationForm from "@/admin/AdminConsoleSchoolRecordPage/AdminConsoleSchoolGeneralInformationForm";
import ActionButtonList from "@/components/ActionButtonList/ActionButtonList";
import {
  modalStyles,
  subtitleStyles,
  buttonStyles,
  iconStyles,
} from "./AdminConsoleDistrictAddSchoolModal.style";

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

const AdminConsoleDistrictAddSchoolModal = ({ onSubmit }) => {
  const [form, setForm] = useState();
  const [modalProps, setActive] = useModal(false);

  const handleAddSchoolClick = () => {
    onSubmit(form);
    setActive(false);
  };

  return (
    <>
      <Button
        flavor={Button.flavors.primary}
        onClick={() => setActive(true)}
        icon={{
          SvgComponent: PlusSVG,
          alignment: Button.iconAlignments.left,
        }}
        __cssFor={{
          root: buttonStyles,
          Icon: { root: iconStyles },
        }}
        aria-label="Add school"
      >
        Add school
      </Button>
      <InfoModal
        __cssFor={modalStyles}
        labelId="addSchool"
        title="Add school"
        onBackgroundClick={() => setActive(false)}
        footer={
          <ActionButtonList
            actionsList={[
              {
                label: "Cancel",
                flavor: Button.flavors.secondary,
                handleClick: () => setActive(false),
              },
              {
                label: "Add school",
                flavor: Button.flavors.primary,
                handleClick: handleAddSchoolClick,
                disabled: !form?.isValid,
              },
            ]}
          />
        }
        {...modalProps}
      >
        <h2 css={subtitleStyles}>Complete the school’s new profile.</h2>
        <AdminConsoleSchoolGeneralInformationForm
          onChange={setForm}
          standalone
        />
      </InfoModal>
    </>
  );
};

AdminConsoleDistrictAddSchoolModal.propTypes = propTypes;

export default AdminConsoleDistrictAddSchoolModal;
